import { api } from "@/lib/api";
import type {
  StaffDepartmentInsightResponse,
  StaffDepartmentsResponse,
} from "@/types/staffDepartments";
import type { StaffInsightQueryParams } from "@/types/staffInsights";

export const staffDepartmentService = {
  listDepartments: async () => {
    const response = await api.get<StaffDepartmentsResponse>("/api/v1/staff-insights/departments");
    return response.data;
  },

  getDepartmentSummary: async (departmentId: string, params: StaffInsightQueryParams) => {
    const response = await api.get<StaffDepartmentInsightResponse>(
      `/api/v1/staff-insights/departments/${departmentId}/insights`,
      { params }
    );
    return response.data;
  },
};
